"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const isFunction_1 = __importDefault(require("lodash/isFunction"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const MenuOptions_1 = __importDefault(require("../MenuOptions"));
const DEFAULT_URL = `/v2/api/stage-notification-types`;
const DATA_STRUCTURE = {
    dataKey: 'data',
    isJsonApi: true,
    label: 'label',
    lastPage: 'meta.page.last_page',
    pageSize: 25,
    type: 'workflowTemplates',
    value: 'id',
};
const ReviewNotificationOptions = (props) => {
    const { handleChange, value, isInvalid = false, labelName } = props;
    const handleChangeOption = (newValue) => {
        if ((0, isFunction_1.default)(handleChange)) {
            handleChange(newValue);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MenuOptions_1.default, { classes: {
                root: styles_modules_less_1.default['notify-root'],
                menu: {
                    menuCtn: styles_modules_less_1.default['notify-root__menuCtn'],
                },
            }, url: DEFAULT_URL, dataStructure: DATA_STRUCTURE, placeholder: "Notify all comments and decisions", value: value, handleChange: handleChangeOption, isInvalid: isInvalid, labelName: labelName })));
};
exports.default = ReviewNotificationOptions;
